import type { PostWithAuthor } from '../types/database';

type GetVisiblePostsOptions = {
  posts: PostWithAuthor[] | undefined;
  userId: string | null | undefined;
  isAdmin: boolean;
};

type ModerationStatus = PostWithAuthor['moderation_status'];

export function getVisiblePostsForViewer({
  posts,
  userId,
  isAdmin,
}: GetVisiblePostsOptions): PostWithAuthor[] {
  const visiblePosts =
    posts?.filter((post) => {
      if (isAdmin) {
        return post.moderation_status !== 'rejected';
      }

      const isApproved = post.moderation_status === 'approved';
      const isOwnPost = post.user_id === userId;

      return isApproved || isOwnPost;
    }) || [];

  if (!isAdmin) {
    return visiblePosts;
  }

  return [...visiblePosts].sort((a, b) => {
    const aIsPending = a.moderation_status === 'pending';
    const bIsPending = b.moderation_status === 'pending';

    if (aIsPending !== bIsPending) {
      return aIsPending ? -1 : 1;
    }

    return (
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
  });
}

export function getVisibleModerationStatusForViewer(
  post: PostWithAuthor,
  userId: string | null | undefined,
  isAdmin: boolean
): ModerationStatus | undefined {
  const isOwner = post.user_id === userId;

  if (isOwner) {
    return post.moderation_status;
  }

  if (isAdmin && post.moderation_status === 'pending') {
    return 'pending';
  }

  return undefined;
}
